import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, BookOpen } from "lucide-react";
import { homeFaq, answerBlock } from "../seoContent";

export const AnswerSection = () => (
  <section className="ans" id="what-ingredients" aria-labelledby="ans-h">
    <h2 className="ans-h" id="ans-h">
      {answerBlock.heading}
    </h2>
    <p className="ans-lead">{answerBlock.answer}</p>
    <dl className="ans-grid">
      {answerBlock.points.map((p) => (
        <div className="ans-item" key={p.term}>
          <dt>{p.term}</dt>
          <dd>{p.text}</dd>
        </div>
      ))}
    </dl>
    <p className="ans-more">
      <BookOpen size={14} aria-hidden="true" />
      <span>
        Want the long answers?{" "}
        <Link to="/ingredient">
          Read the InZoRAH ingredient blog
        </Link>{" "}
        or look one up in the{" "}
        <Link to="/ingredients">A-Z ingredient glossary</Link>.
      </span>
    </p>
  </section>
);

export const FaqSection = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="faq" id="faq" aria-labelledby="faq-h">
      <h2 className="faq-h" id="faq-h">
        Frequently asked questions
      </h2>
      <div className="faq-list">
        {homeFaq.map((f, i) => {
          const isOpen = open === i;
          return (
            <article className={`faq-item ${isOpen ? "is-open" : ""}`} key={f.question}>
              <h3>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span>{f.question}</span>
                  <ChevronDown size={18} aria-hidden="true" />
                </button>
              </h3>
              <div className="faq-a" hidden={!isOpen}>
                <p>{f.answer}</p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default FaqSection;
